import type { ModuleBlueprint } from "../registry/types";
import { commerceBlueprint } from "./commerce";
import { modelsBlueprint } from "./models";

export { commerceBlueprint, COMMERCE_SEGMENTS } from "./commerce";
export { modelsBlueprint, MODELS_SEGMENTS } from "./models";

/** Kayıtlı blueprint'ler. Sıra önemsiz; registry id ile map'ler. */
export const MODULE_BLUEPRINTS: ReadonlyArray<ModuleBlueprint<unknown>> = [
  commerceBlueprint as ModuleBlueprint<unknown>,
  modelsBlueprint as ModuleBlueprint<unknown>,
];
